import { createContext, useContext } from "react";
import DBObjectIds from "../constants/DBObjectsIdsEnum";
import WorkflowProcessIds from "../constants/WorkflowProcessIdsEnum";

const WorkflowContext = createContext({
  workflowParams: {
    Workflow: {
      WorkflowProcessId: WorkflowProcessIds.NewRegistration,
      WorkflowStepId: 0,
      DBObjectId: DBObjectIds.StudentFirstRegistrations,
      DBObjectLocationId: 0,
      CreatedBy: localStorage.getItem("userId") || "",
      Comments: "",
    },
  },
  setWorkflowParams: () => {},
});

export const useWorkflow = () => useContext(WorkflowContext);

export default WorkflowContext;
